import { useAppSelector } from '@store';
import { PermissionEnum } from '@ui/src';
import StepItem from '../../../../components/new-application/common/steps/step-item';
import NewApplicationCorporateInfoStepOne from '../../../../components/new-application/corporate/step-one';
import NewApplicationCorporateInfoStepTwo from '../../../../components/new-application/corporate/step-two';
import NewApplicationCorporateInfoStepThree from '../../../../components/new-application/corporate/step-three';
import NewApplicationCorporateInfoStepFour from '../../../../components/new-application/corporate/step-four';
import NewApplicationCorporateInfoStepFive from '../../../../components/new-application/corporate/step-five';
import NewApplicationCorporateInfoStepSix from '../../../../components/new-application/corporate/step-six';
import Agreements from '../../../../components/new-application/common/agreements/agreements';
import OngoingMonitoring from '../../common/ongoing-monitoring';
import { NewApplicationStepStatus } from '../../types';
import { ApplicationStepsTypes } from './types';

const ApplicationSteps = ({
  applicationStepsStatus,
  control,
  errors,
  fields,
  newApplicationInfo,
  setValue,
  activePermissions,
  clearErrors,
  questionnarieControl,
  questionnarieClearErrors,
  questionnarieErrors,
  questionnarieFields,
  relationshipToTheCustomerDictionary,
  sourceOfWealth,
  busniessActivities,
  customerMainCleints,
  salesChannels,
  questionnarieSetValue,
  customerSourceOfWealth,
  customerSourceOfFunds,
  annualIncomes,
  totalIncomeError,
  setTotalIncomeError,
  typeOfAccounts,
  accountsCurrenciesValues,
  setAccountsCurrenciesValues,
  onDeleteAccountCurrencies,
  selectedAccountsCurrencyId,
  deleteAccountsCurrenciesInProgress,
  accountsFlowsValues,
  setAccountsFlowsValues,
  selectedExpectedFundsOriginsId,
  accountsCurrenciesIsLoading,
  accountsCurrenciesIsFetching,
  accountsFlowsIsLoading,
  accountsFlowsIsFetching,
  expectedFundsOriginsIsLoading,
  expectedFundsOriginsIsFetching,
  deleteExpectedFundsOriginsInProgress,
  onDeleteExpectedFundsOrigins,
  expectedFundsOriginsValues,
  setExpectedFundsOriginsValues,
  customersSuppliersStepEnabled,
  mainRepresentativeApplications,
  applicationId,
  initialFields,
  onApplicationCOFSubmit,
  setDefaultFormValues,
  defaultFormValues,
  companyOfficialsApplications,
  defaultQuestionnarieFormValues,
  getApplicationChat,
  onSaveAccountsCurrencies,
  onSaveAccountsFlows,
  onSaveExpectedFundsOrigins,
  ongoingMonitoring,
  ongoingCheckingStatus,
  documents,
  search,
  allowedDocumentsCategories,
  agreements,
  agreementsIsLoading,
  infoDictionariesIsLoading,
  questionnarieIsLoading,
  agreementsErrorsList,
}: ApplicationStepsTypes) => {
  const {
    currenciesList: currencies,
    countriesList: countries,
    baseCurrency,
    settings,
    currencies: currenciesList,
  } = useAppSelector((state) => state.root);

  const companyLegalName = settings?.find(
    (item) => item.key === 'COMPANY-LEGAL-NAME',
  )?.data?.value;

  return (
    <>
      <StepItem
        title="Step 1"
        status={applicationStepsStatus?.stepOne as NewApplicationStepStatus}
        id="step-1"
        zIndex={10}
      >
        <NewApplicationCorporateInfoStepOne
          control={control}
          errors={errors}
          countries={countries}
          fields={fields}
          sicCodes={newApplicationInfo?.sicCodes}
          countriesOfInterest={newApplicationInfo?.countriesOfInterestIds}
          setValue={setValue}
          status={newApplicationInfo?.status}
          isEditable={activePermissions?.includes(
            PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
          )}
          applicationScheme={newApplicationInfo?.applicationScheme}
          clearErrors={clearErrors}
          questionnarieControl={questionnarieControl}
          questionnarieClearErrors={questionnarieClearErrors}
          questionnarieErrors={questionnarieErrors}
          questionnarieFields={questionnarieFields}
          requiredCurrencies={newApplicationInfo?.requiredCurrenciesCryptoId}
          currencies={currencies}
          regulatedCompanyScheme={Boolean(
            newApplicationInfo?.applicationScheme?.id ===
            'cdbb8c71-90e6-4a5e-964f-e55169e0c4df',
          )}
          relationshipToTheCustomerDictionary={
            relationshipToTheCustomerDictionary
          }
          sourceOfWealth={sourceOfWealth}
          baseCurrency={baseCurrency}
          busniessActivities={busniessActivities}
          customerMainCleints={customerMainCleints}
          salesChannels={salesChannels}
          questionnarieSetValue={questionnarieSetValue}
          customerSourceOfWealth={customerSourceOfWealth}
          customerSourceOfFunds={customerSourceOfFunds}
          companyLegalName={companyLegalName as string}
          annualIncomes={annualIncomes}
          totalIncomeError={totalIncomeError}
          setTotalIncomeError={setTotalIncomeError}
          typeOfAccounts={typeOfAccounts}
          accountsCurrenciesValues={accountsCurrenciesValues}
          setAccountsCurrenciesValues={setAccountsCurrenciesValues}
          onDeleteAccountCurrencies={onDeleteAccountCurrencies}
          selectedAccountsCurrencyId={selectedAccountsCurrencyId}
          deleteAccountsCurrenciesInProgress={
            deleteAccountsCurrenciesInProgress
          }
          accountsFlowsValues={accountsFlowsValues}
          setAccountsFlowsValues={setAccountsFlowsValues}
          currenciesList={currenciesList}
          selectedExpectedFundsOriginsId={selectedExpectedFundsOriginsId}
          accountsCurrenciesIsLoading={accountsCurrenciesIsLoading}
          accountsCurrenciesIsFetching={accountsCurrenciesIsFetching}
          accountsFlowsIsLoading={accountsFlowsIsLoading}
          accountsFlowsIsFetching={accountsFlowsIsFetching}
          expectedFundsOriginsIsLoading={expectedFundsOriginsIsLoading}
          expectedFundsOriginsIsFetching={expectedFundsOriginsIsFetching}
          deleteExpectedFundsOriginsInProgress={
            deleteExpectedFundsOriginsInProgress
          }
          onDeleteExpectedFundsOrigins={onDeleteExpectedFundsOrigins}
          expectedFundsOriginsValues={expectedFundsOriginsValues}
          setExpectedFundsOriginsValues={setExpectedFundsOriginsValues}
          questionnarieIsLoading={questionnarieIsLoading}
        />
      </StepItem>
      {customersSuppliersStepEnabled && (
        <StepItem
          title="Step 2"
          status={applicationStepsStatus?.stepTwo as NewApplicationStepStatus}
          id="step-2"
          zIndex={9}
        >
          <NewApplicationCorporateInfoStepTwo
            suppliers={newApplicationInfo?.suppliers}
            customers={newApplicationInfo?.customers}
            setValue={setValue}
            status={newApplicationInfo?.status}
            isEditable={activePermissions?.includes(
              PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
            )}
            errors={errors}
            clearErrors={clearErrors}
            applicationScheme={newApplicationInfo?.applicationScheme}
          />
        </StepItem>
      )}
      <StepItem
        title={customersSuppliersStepEnabled ? 'Step 3' : 'Step 2'}
        status={applicationStepsStatus?.stepThree as NewApplicationStepStatus}
        id="step-3"
        zIndex={8}
      >
        <NewApplicationCorporateInfoStepThree
          control={control}
          status={newApplicationInfo?.status}
          isEditable={activePermissions?.includes(
            PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
          )}
          errors={errors}
          clearErrors={clearErrors}
          infoDictionariesIsLoading={infoDictionariesIsLoading}
        />
      </StepItem>
      <StepItem
        title={customersSuppliersStepEnabled ? 'Step 4' : 'Step 3'}
        status={applicationStepsStatus?.stepFour as NewApplicationStepStatus}
        id="step-4"
        zIndex={7}
      >
        <NewApplicationCorporateInfoStepFour
          mainRepresentativeApplications={mainRepresentativeApplications}
          applicationId={applicationId}
          setValue={setValue}
          status={newApplicationInfo?.status}
          isEditable={activePermissions?.includes(
            PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
          )}
          errors={errors}
          applicationStatus={newApplicationInfo?.status}
          initialFields={initialFields}
          fields={fields}
          onSubmit={onApplicationCOFSubmit}
          setDefaultFormValues={setDefaultFormValues}
          defaultFormValues={defaultFormValues}
          companyOfficial={companyOfficialsApplications}
          questionnarieFields={questionnarieFields}
          defaultQuestionnarieFormValues={defaultQuestionnarieFormValues}
          applicationScheme={newApplicationInfo?.applicationScheme}
          getApplicationChat={getApplicationChat}
          onSaveAccountsCurrencies={onSaveAccountsCurrencies}
          onSaveAccountsFlows={onSaveAccountsFlows}
          onSaveExpectedFundsOrigins={onSaveExpectedFundsOrigins}
        />
      </StepItem>
      <StepItem
        title={customersSuppliersStepEnabled ? 'Step 5' : 'Step 4'}
        status={applicationStepsStatus?.stepFive as NewApplicationStepStatus}
        id="step-5"
        zIndex={6}
      >
        <NewApplicationCorporateInfoStepFive
          setValue={setValue}
          mainRepresentativeApplications={mainRepresentativeApplications}
          companyOfficial={companyOfficialsApplications}
          applicationId={applicationId}
          status={newApplicationInfo?.status}
          isEditable={activePermissions?.includes(
            PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
          )}
          applicationStatus={newApplicationInfo?.status}
          initialFields={initialFields}
          setDefaultFormValues={setDefaultFormValues}
          defaultFormValues={defaultFormValues}
          fields={fields}
          onSubmit={onApplicationCOFSubmit}
          onSaveAccountsCurrencies={onSaveAccountsCurrencies}
          onSaveAccountsFlows={onSaveAccountsFlows}
          onSaveExpectedFundsOrigins={onSaveExpectedFundsOrigins}
        />
      </StepItem>
      <StepItem
        title={customersSuppliersStepEnabled ? 'Step 6' : 'Step 5'}
        status={applicationStepsStatus?.stepEight as NewApplicationStepStatus}
        id="step-6"
        zIndex={5}
      >
        <OngoingMonitoring
          status={newApplicationInfo?.status}
          applicationId={newApplicationInfo?.id}
          ongoingMonitoring={ongoingMonitoring}
          ongoingCheckingStatus={ongoingCheckingStatus}
        />
      </StepItem>
      <StepItem
        title={customersSuppliersStepEnabled ? 'Step 7' : 'Step 6'}
        status={applicationStepsStatus?.stepSix as NewApplicationStepStatus}
        id="step-7"
        zIndex={4}
      >
        <NewApplicationCorporateInfoStepSix
          documents={documents}
          applicationId={applicationId}
          applicationStatus={newApplicationInfo?.status}
          search={search}
          allowedDocumentsCategories={allowedDocumentsCategories}
          errors={errors}
          clearErrors={clearErrors}
          renameAvailable={activePermissions?.includes(
            PermissionEnum.APPLICATIONS_CUSTOMERS_DOCUMENTS_EDIT_ACTION,
          )}
        />
      </StepItem>
      {(!newApplicationInfo?.applicationScheme ||
        (newApplicationInfo.applicationScheme &&
          newApplicationInfo.applicationScheme.agreementsActive) ||
        (newApplicationInfo.applicationScheme &&
          newApplicationInfo.applicationScheme.agreementsActive === null)) && (
        <StepItem
          title={customersSuppliersStepEnabled ? 'Step 8' : 'Step 7'}
          status={applicationStepsStatus?.stepSeven as NewApplicationStepStatus}
          id="step-8"
          zIndex={3}
        >
          <Agreements
            list={agreements}
            errors={errors}
            zIndex={13}
            agreementsIsLoading={agreementsIsLoading}
            agreementsErrorsList={agreementsErrorsList}
          />
        </StepItem>
      )}
    </>
  );
};

export default ApplicationSteps;
